import { Button, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import React from "react";
import { Container, Header, Content, UnsuportedFileDisclaimer } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    maxWidth: "320px",
    width: "100%",
    minHeight: 50,
    marginTop: "16px",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

interface UnsuportedFileModalProps {
  setModalStatus: (status: boolean) => void;
  blobUrl: string;
  fileType: string;
  fileName: string;
}

const UnsuportedFileModal = ({
  setModalStatus,
  blobUrl,
  fileType,
  fileName,
}: UnsuportedFileModalProps) => {
  const classes = useStyles();
  const { i18n, t } = useTranslation();

  const handleDownloadUnsuportedFile = () => {
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${fileName}.${fileType}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container>
      <Header>
        <span
          style={{ float: "right", cursor: "pointer" }}
          onClick={() => {
            setModalStatus(false);
          }}
        >
          [X] Fechar
        </span>
      </Header>

      <Content>
        <UnsuportedFileDisclaimer>
          {t("menu.fileManagement.info.unsupportedFileDisclaimer")}
        </UnsuportedFileDisclaimer>

        <Button
          variant="contained"
          onClick={handleDownloadUnsuportedFile}
          className={classes.button}
        >
          {t("forms.dialog.download")}
        </Button>
      </Content>
    </Container>
  );
};

export default UnsuportedFileModal;
